<div class="go-back">
    <a (click)="onActionClick()"><mat-icon>arrow_back</mat-icon></a>
    <p>{{ text }}</p>
</div>
